import {LinkedEntities, LinkedEntityItem} from '@app/views/databrowsing/model/linked-entities.models';

export interface IEntity {
}

export interface ILightEntity {
    idValue: any;
    districtName: string;
}

export class Entity {
    title: string;
    entity: string;
}

export class Metadata {
    [key: string]: string;
}

export class SystemId {
    type: string;
    systemId: string;
}

export class RosterEntity implements IEntity {
    guid: Guid;
    sisIds: SystemId[];
    createdAt: string;
    lastUpdatedAt: string;
    effectiveTimestamp: string;
    oneRosterDateLastModified: string;
    status: string;
    metadata: Metadata;
    nullValues: string[];
}

export class DistrictEntity extends RosterEntity {
    localId: string;
    districtId: Guid;
}

export class Guid {
    guidValue: string;
    // gid: number;
    // keyName: string;
    // keyValue: string;
    // invalid: boolean;

    static getValue(guid: Guid): string {
        return (guid && typeof guid === 'object' && guid.guidValue)
            ? guid.guidValue
            : guid ? String(guid) : '';
    }

    static getLinks(links: LinkedEntityItem[], guidList: Guid[], replaceLink?: LinkedEntityItem): LinkedEntityItem[] {
        let mappedLinks = LinkedEntities.getLinks<Guid>(
            links,
            guidList,
            (guid: Guid) => <LinkedEntityItem>{guid: Guid.getValue(guid)},
            (guid: Guid) => Guid.getValue(guid)
        );

        if (replaceLink) {
            mappedLinks = mappedLinks.map((mappedLink: LinkedEntityItem) => mappedLink.guid == replaceLink.guid ? replaceLink : mappedLink);
        }

        return mappedLinks;
    }
}

export const LTI_LINE_ITEM_URLS_USERS_MAPPING_METADATA_KEY = 'LTI_LINE_ITEM_URLS_USERS_MAPPING';
export const GOOGLE_CLASSROOM_LINKS_METADATA_ATTR_NAME = 'google_classroom_links';

export class LTIUrlsUsersMappingData {
    userIdsByLineItemUrl: LTIUrlsUsersMapping;
    sourcedIdsByServiceOutcomeUrl: LTIUrlsUsersMapping;
}

export class LTIUrlsUsersMapping {
    [key: string]: string[];
}

